import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { IconButton, Popover } from '@material-ui/core';
import React, { useState } from 'react';
import { saveSearchCondition, isViewWasChanged, onClickOpenMoveView, isDisplayBtnSettingViewIcon } from '../handler/ViewHandler';
import { DialogConfirmDeleteView } from './DialogConfirmDeleteView';
import { DialogConfirmHideView } from './DialogConfirmHideView';

export const SettingView = (props) => {
    const [isConfirmDeleteView, setIsConfirmDeleteView] = useState(false);
    const [isConfirmHideView, setIsConfirmHideView] = useState(false);
    const [openSettingMenu, setOpenSettingMenu] = useState(null);

    const onClickViewSetting = (event) => {
        setOpenSettingMenu(event.currentTarget);
    };

    const handleClose = () => {
        setOpenSettingMenu(null);
    };

    const onClickDeleteView = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(props.view, props);
        if (isViewChanged) {
            props.setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmDeleteView(true);
        }
    };

    const onClickHideView = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(props.view, props);
        if (isViewChanged) {
            props.setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmHideView(true);
        }
    };

    const onClickSaveSearchCondition = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(props.view, props);
        if (isViewChanged) {
            props.setIsOpenDialogViewChanged(true);
        } else {
            await saveSearchCondition(props.view, props);
        }
    };

    const onClickMoveView = async () => {
        setOpenSettingMenu(null);
        
        //check view was changed
        let isViewChanged = await isViewWasChanged(props.view, props);
        if (isViewChanged) {
            props.setIsOpenDialogViewChanged(true);
        } else {
            onClickOpenMoveView(props.view, props);
        }
        
    };


    const isShowOptionSaveCondition = () => {
        if(props.viewSelected.id !== props.view.id) return false;

        return (
            props.viewSelected.viewType === Constant.VIEW_TYPE.CUSTOM ||
            (props.viewStructure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM &&
                props.viewSelected.viewType === Constant.VIEW_TYPE.DEFAULT)
        );
    };

    return (
        <>
            {isDisplayBtnSettingViewIcon(
                props.isCustomer,
                props.userRoleInProject,
                props.viewStructure,
                props.isViewFromKnowledgePanel
            ) && (
                <IconButton
                    className="btn-showMore"
                    onClick={onClickViewSetting}
                    style={{ verticalAlign: 'middle',  padding: '4px 10px' }}
                >
                    <img src="/assets/image/icon-nav-tabs.svg" alt="" />
                </IconButton>
            )}
            <Popover
                className="navTabs-dropMenu"
                id={`${props.view.id}-simple-menu`}
                anchorEl={openSettingMenu}
                keepMounted
                open={Boolean(openSettingMenu)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <ul>
                    <li onClick={onClickHideView}>
                        <span className='navTabs-item'><img src="/assets/image/icon-tabs-hide.svg" alt="" /></span>
                        <span className='navTabs-text'>非表示</span>
                    </li>
                    {props.view.viewType === Constant.VIEW_TYPE.CUSTOM && (
                        <li onClick={onClickDeleteView}>
                            <span className='navTabs-item'><img src="/assets/image/icon-tabs-delete.svg" alt="" /></span>
                            <span className='navTabs-text'>削除</span>
                        </li>
                    )}
                    <li onClick={onClickMoveView}>
                        <span className='navTabs-item'><img src="/assets/image/icon-tabs-move.svg" alt="" /></span>
                        <span className='navTabs-text'>移動</span>
                    </li>
                    {isShowOptionSaveCondition() && (
                        <li onClick={onClickSaveSearchCondition}>
                            <span className='navTabs-item'><img src="/assets/image/icon-tabs-search.svg" alt="" /></span>
                            <span className='navTabs-text'>検索条件保存</span>
                        </li>
                    )}
                </ul>
            </Popover>

            <DialogConfirmDeleteView
                viewDelete={props.view}
                isConfirmDeleteView={isConfirmDeleteView}
                setIsConfirmDeleteView={setIsConfirmDeleteView}
                {...props}
            />

            <DialogConfirmHideView
                viewHide={props.view}
                isConfirmHideView={isConfirmHideView}
                setIsConfirmHideView={setIsConfirmHideView}
                {...props}
            />
        </>
    );
};
